import { Component, OnInit } from "@angular/core";
import { GlobalService } from "src/app/services/global.service";
import Swal from "sweetalert2";
import { NgxSpinnerService } from "ngx-spinner";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { CommonService } from "src/app/services/common.service";
import * as moment from "moment";
import { DatePipe } from "@angular/common";
import { Router, ActivatedRoute } from "@angular/router";
import * as SecureLS from "secure-ls";
import {
  FormBuilder,
  FormGroup,
  FormArray,
  FormControl,
  Validators,
} from "@angular/forms";
import { ExcelServicesService } from "../../../services/excel.service";
import { StorageService } from "../../../services/storage.service";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
@Component({
  selector: "app-audio-report",
  templateUrl: "./audio-report.component.html",
  styleUrls: ["./audio-report.component.css"],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class AudioReportComponent implements OnInit {
  private ls = new SecureLS({ encodingType: "aes" });
  expandedElement = false;
  total_count = 0;
  prolength: number = 0;
  htmlpageshow: boolean;
  page_count = [];
  editid: any;
  video: any;
  vid: any;
  maxDate = new Date();
  pageshow = true;
  getVideo: any;
  videoList: any[] = [];
  searchForm: FormGroup;
  uivideoList: any;
  excelVideoList: any[];
  listVideo: any;
  department_id: any;
  filter_from: any;
  filter_end: any;
  page: number = 1;
  page_size: number = 10;
  department_details: any;
  subject_details: any;
  form: FormGroup;
  batch_id: string;
  filter: any;
  department: any;
  dept: any;
  classroom: any;
  class: any;
  batch: any;
  subject: any;
  subjectData: any;
  total: number;
  p: number;
  pagedItems: any[];
  batchData1: any;
  check: number;
  dropbox: Array<Object> = [];
  recrange: any;
  pageno: any;
  filtervalues: boolean;
  chiparray = [];
  hod: any;
  sessionData: any;
  minDate: Date;
  findedVal: any;
  professor_id: any;
  professorname: Object;
  professorData: any;
  isLoginType: boolean;
  role: number;
  constructor(
    private storageService: StorageService,
    private datepipe: DatePipe,
    public globalService: GlobalService,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    private ExcelServicesService: ExcelServicesService,
    public commonService: CommonService
  ) {
    this.role = this.storageService.getRole();
  }
  async ngOnInit() {
    this.hod = this.storageService.getHod();
    this.maxDate = new Date();
    this.minDate = new Date();
    this.maxDate.setDate(this.maxDate.getDate() - 1);
    this.searchForm = this.fb.group({
      id: [null],
      proname: [null],
      proffname: [null],
      date: [null, [Validators.required]],
      depname: [null],
      batchname: [null],
      session: [null],
    });
    if (this.route.queryParams["value"].loginType == "impersonate") {
      this.isLoginType = true;
    }
    if (this.storageService.getRole() == 4) {

      this.professor_id = this.storageService.getProfessor();
      this.department_id = this.storageService.getDepartment();

      this.searchForm.controls["proname"].setValue(this.professor_id);
      this.searchForm.controls["depname"].setValue(this.department_id);

      this.searchForm.controls["depname"].disable();

      if (this.hod !== 1) {
        this.searchForm.controls["proname"].disable();
      }
    }

    this.getDepartment();
    this.getProfessor();
    this.getSession();
    this.getBatch();
    this.getVideoDetails();
  }

  get forms() {
    return this.searchForm.controls;
  }

  getvalue(event: any, rec: any) {
    this.spinner.show();
    this.recrange = rec;
    this.pageno = event;
    this.exportAsXLSX();
  }

  async dropboxdown() {
    this.dropbox = [];
    var count = 1000,
      tempcount = 1000,
      c1,
      c2;
    this.check = Math.ceil(this.total_count / count);
    var cvar = 1;
    for (let i = 1; i <= this.check; i++) {
      c1 = cvar;
      c2 = count;
      cvar = cvar + tempcount;
      count += tempcount;
      this.dropbox.push({ value: i, records: c1 + "-" + c2 });
    }
  }

  async onDepartmentChange(departmentId: any) {
    this.department_id = departmentId || null;

    // Clear professor selection
    this.professor_id = null;
    this.searchForm.patchValue({
      proffname: null,
      proname: null
    });

    await this.getProfessor();
  }

  async getProfessor() {
    this.spinner.show();

    this.professorData = [];
    const currentDeptId = this.department_id || this.searchForm?.get("depname")?.value;

    if (this.role !== 4 && !currentDeptId) {
      this.professorname = { content: [] };
      this.professorData = [];
      this.spinner.hide();
      return;
    }

    const filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
      department_id: currentDeptId,
    };

    try {
      const response = await this.globalService.get(
        "user/profeser/dropdown",
        filter,
        true
      );

      this.professorData = response["content"] || [];

      // Clear selected professor if not available in selected department
      if (this.professor_id) {
        const exists = this.professorData.find(
          x => x.id == this.professor_id
        );

        if (!exists) {
          this.professor_id = null;
          this.searchForm.patchValue({
            proffname: null,
            proname: null
          });
        }
      }

      // Role 4 Non-HOD
      if (this.storageService.getRole() == 4 && this.hod !== 1) {

        this.professor_id = this.storageService.getProfessor();

        const professor = this.professorData.find(
          x => x.id == this.professor_id
        );

        if (professor) {
          this.department_id = professor.department_id;

          this.searchForm.controls["depname"].setValue(
            professor.department_id
          );

          this.searchForm.controls["depname"].disable();

          this.searchForm.controls["proname"].setValue(
            this.professor_id
          );
        }
      }

    } finally {
      this.spinner.hide();
    }
  }


  async getDepartment() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.department = await this.globalService.get(
      "department/list/dropdown",
      filter,
      true
    );

    this.dept = this.department["content"];
    this.spinner.hide();
  }
  async getSession() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    let session = await this.globalService.get(
      "session/dropdown",
      filter,
      true
    );

    this.sessionData = session["content"];
    this.forms["session"].setValue(
      this.storageService.getCurrentSession(this.sessionData)?.session
    );

    this.findedVal = this.sessionData.find(
      (list) => list.session === this.searchForm.controls['session']?.value
    );
    this.onSessionChangeEvent(true);
    this.Filter();
    this.spinner.hide();
  }

  onSessionChangeEvent(isInitLoad?) {
    this.forms["date"].setValue(null);
    this.getFilterDate(null);
    let sessionVal = this.forms["session"].value;
    if (sessionVal) {
      this.findedVal = this.sessionData.find(
        (list) => list.session === sessionVal
      );
      this.minDate.setDate(new Date(this.findedVal.start_date).getDate());
      this.minDate.setMonth(new Date(this.findedVal.start_date).getMonth());
      this.minDate.setFullYear(
        new Date(this.findedVal.start_date).getFullYear()
      );
      // this.maxDate.setDate(new Date(this.findedVal.end_date).getDate());
      // this.maxDate.setMonth(new Date(this.findedVal.end_date).getMonth());
      // this.maxDate.setFullYear(new Date(this.findedVal.end_date).getFullYear());
      if (isInitLoad) {
        let splitedChipArray = null;
        if (this.chiparray.length) {
          this.chiparray.forEach((elem) => {
            if (elem.split(" : ")[0] === "Date") {
              splitedChipArray = elem.split(" : ")[1].split(" - ");
            }
          })
        }
        if (splitedChipArray?.length) {
          const convertedDates = splitedChipArray.map(dateStr => new Date(dateStr));
          this.forms["date"].setValue(convertedDates);
          this.getFilterDate(convertedDates);
        } else {
          this.forms["date"].setValue([new Date(), new Date()]);
          this.getFilterDate([new Date(), new Date()]);
        }
      }
    } else {
      this.forms["date"].setValue(null);
      this.getFilterDate(null);
    }
  }

  getFilterDate(filter_date) {
    if (filter_date) {
      this.filter = filter_date;

      this.filter_from = moment(this.filter[0]).format("YYYY-MM-DD");
      this.filter_end = moment(this.filter[1]).format("YYYY-MM-DD");
      var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
      var diffDays =
        Math.floor(
          new Date(this.filter_from).getTime() -
          new Date(this.filter_end).getTime()
        ) / oneDay;
      if (-diffDays > 180) {
        Swal.fire({
          text: "Please select dates within 180 days",

          icon: "warning",

          confirmButtonText: "OK",

          confirmButtonColor: "#808080",
        });
        this.searchForm.controls["date"].setValue("");
      }
    }
  }

  async getBatch() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.batch = await this.globalService.get(
      "batch/list/dropdown",
      filter,
      true
    );

    this.batchData1 = this.batch["content"];
    this.spinner.hide();
  }

  getUtcToLocale(dateValue, timeValue, isDateRequested) {
    return this.globalService.getUtcToLocale(dateValue, timeValue, isDateRequested);
  }
  async getPage(page: number) {
    this.page = page;
    this.getVideoDetails();
    const res = await this.serverCall(this.videoList, page);
    this.total = this.total_count;
    this.p = page;
    this.pagedItems = res;
  }

  async serverCall(sample: any[], page: number) {
    const perPage = 10;
    const start = (page - 1) * perPage;
    const end = start + perPage;
    return sample;
  }

  getVideoDetails() {
    this.spinner.show();
    if (this.page === 1) {
      this.listVideo = [];
    }

    let filter: any = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      start_date: this.filter_from || moment(new Date()).format("YYYY-MM-DD"),
      end_date: this.filter_end || moment(new Date()).format("YYYY-MM-DD"),
      department_id: this.department_id,
      batch_id: this.batch_id,
      professor_id: this.professor_id,
      page: this.page,
      page_size: this.page_size,
      session_id: this.findedVal?.id,
    };

    const dateKeyExists = this.chiparray.some((chip) => chip.startsWith("Date :"));

    if (!dateKeyExists) {
      this.chiparray.push("Date :" + " " + filter.start_date + " - " + filter.end_date);
    }
    this.globalService
      .get("classVideoDetail/audio/detail/report", filter)
      .then((data) => {
        this.getVideo = data;
        this.videoList = this.getVideo["content"]["rows"];

        this.prolength = this.videoList.length;

        if (this.getVideo["status"] === 200) {
          this.videoList = this.getVideo["content"]["rows"];
          this.videoList = this.videoList.map((list) => {
            list["isExpand"] = false;
            return list;
          });
          this.total_count = this.getVideo["content"].count;

          if (this.pageshow === true) {
            this.page_count = [];
            let page_count = Math.ceil(this.total_count / this.page_size);
            if (page_count > 1) {
              this.htmlpageshow = true;
            } else {
              this.htmlpageshow = false;
            }
          }
        }
      });
    this.dropboxdown();
    this.spinner.hide();
  }

  getUtcTimeToLocale(dateValue, timeValue, isDateRequested) {
    var UTCDate = moment
      .utc(dateValue + " " + timeValue)
      .toDate()
      .toLocaleTimeString("en-US");
    return UTCDate;
  }
  async exportAsXLSX(): Promise<void> {
    this.spinner.show();

    let professorId = this.professor_id;
    if (window.location.href.indexOf("impersonate") !== -1) {
      professorId = this.storageService.getProfessor();
    }

    let filter: any = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      start_date: this.filter_from,
      end_date: this.filter_end,
      session_id: this.findedVal?.id,
      department_id: this.department_id,
      batch_id: this.batch_id,
      professor_id: professorId,
      page: this.total_count > 1000 ? this.pageno : 1,
      page_size: 1000,
    };
    this.getVideo = await this.globalService.get(
      "classVideoDetail/audio/detail/report",
      filter
    );

    this.excelVideoList = this.getVideo["content"]["rows"];
    var startTM;
    var endTM;
    this.excelVideoList.forEach((e, i) => {
      startTM = this.getUtcTimeToLocale(
        this.excelVideoList[i].start_date,
        this.excelVideoList[i].start_time,
        ""
      );
      this.excelVideoList[i]["start_time"] = startTM;
      endTM = this.getUtcTimeToLocale(
        this.excelVideoList[i].end_date,
        this.excelVideoList[i].end_time,
        ""
      );
      this.excelVideoList[i]["end_time"] = endTM;
    });

    this.uivideoList = this.excelVideoList.map((item: any) => {
      return {
        CLASS_ROOM_NAME: item.classroom_details.name,
        DEPARTMENT_NAME: item.department_details.name,
        AUDIO_AVAILABILITY: item.audio_availability,
        AUDIO_Percentage: item.has_audio ? "available" : "not available",
        SUBJECT_NAME: item.subject_details.name,
        PROFESSOR_NAME: item.professor_details
          ? item.professor_details.first_name + item.professor_details.last_name
          : "",
        BATCH: item.batch_details.batch,
        START_DATE: item.start_date,
        END_DATE: item.end_date,
        START_TIME: item.start_time,
        END_TIME: item.end_time,
      };
    });

    this.ExcelServicesService.exportAsExcelFile(
      this.uivideoList,
      "Audio report" + " " + [this.recrange]
    );
    this.recrange = " ";
    this.total_count = this.getVideo["content"].count;
    this.spinner.hide();
  }

  loadMore(index) {
    this.pageshow = true;
    this.page = index;
    this.getVideoDetails();
  }
  previous() {
    this.pageshow = true;
    this.page = this.page - 1;
    this.getVideoDetails();
  }
  next() {
    this.pageshow = true;
    this.page = this.page + 1;
    this.getVideoDetails();
  }
  expandRow(eList) {
    this.videoList.forEach((list) => {
      if (eList.id === list.id) {
        list["isExpand"] = true;
      } else {
        list["isExpand"] = false;
      }
    });
  }
  collapseRow(eList) {
    this.videoList.forEach((list) => {
      list["isExpand"] = false;
    });
  }
  openScrollableContent(longContent) {
    this.findedVal = null;
    if (this.ls.get("token")) {
      this.modalService.open(longContent, { scrollable: true });
    }

    // this.searchForm.reset();
    if (!this.forms["session"].value) {
      this.forms["session"].setValue(
        this.storageService.getCurrentSession(this.sessionData)?.session
      );
    }
    this.onSessionChangeEvent(true);
    if (this.storageService.getRole() === 4 && this.hod == 1) {
      this.searchForm.controls["depname"].setValue(
        this.storageService.getDepartment()
      );
      this.department_id = this.storageService.getDepartment();
      this.searchForm.controls["depname"].disable();
      this.searchForm.controls["proname"].setValue(
        this.storageService.getProfessor()
      );
      this.professor_id = this.storageService.getProfessor();
    }
    if (this.storageService.getRole() === 4 && this.hod !== 1) {
      this.searchForm.controls["proname"].setValue(
        this.storageService.getProfessor()
      );
      this.professor_id = this.storageService.getProfessor();
      this.searchForm.controls["proname"].disable();
      const professor = this.professorData?.find(
        p => p.id == this.professor_id
      );

      if (professor) {
        this.department_id = professor.department_id;
        this.searchForm.controls["depname"].setValue(professor.department_id);
        this.searchForm.controls["depname"].disable();
      }
    }
  }
  openActionContent(shortContent) {
    this.modalService.open(shortContent, { scrollable: true });
  }

  Filter() {

    this.filtervalues = true;
    this.chiparray = [];

    this.department_id = this.searchForm.get("depname")?.value;
    this.batch_id = this.searchForm.get("batchname")?.value;

    this.professor_id =
      this.searchForm.get("proffname")?.value ||
      this.searchForm.get("proname")?.value;

    if (this.searchForm.get("session")?.value) {
      this.chiparray.push(
        "Session : " + this.searchForm.get("session")?.value
      );
    }

    // Professor chip
    if (this.professor_id) {
      const professor = (this.professorData || []).find(
        x => x.id == this.professor_id
      );

      if (professor) {
        this.chiparray.push(
          "Proff: " + professor.first_name + " " + professor.last_name
        );
      }
    }

    // Department chip
    if (this.department_id) {
      const dept = (this.dept || []).find(
        x => x.id == this.department_id
      );

      if (dept) {
        this.chiparray.push("Dept: " + dept.name);
      }
    }

    // Batch chip
    if (this.batch_id) {
      const batch = (this.batchData1 || []).find(
        x => x.id == this.batch_id
      );

      if (batch) {
        this.chiparray.push("Batch: " + batch.batch);
      }
    }

    this.page = 1;
    this.pageshow = true;

    this.getVideoDetails();
  }

  res() {

    this.filtervalues = false;
    this.chiparray = [];

    this.filter_from = null;
    this.filter_end = null;
    this.batch_id = null;

    this.searchForm.reset();

    this.forms["session"].setValue(
      this.storageService.getCurrentSession(this.sessionData)?.session
    );

    this.findedVal = this.sessionData.find(
      x => x.session == this.forms["session"].value
    );

    // Professor & HOD
    if (this.storageService.getRole() == 4) {

      this.department_id = this.storageService.getDepartment();
      this.professor_id = this.storageService.getProfessor();

      this.searchForm.controls["depname"].setValue(this.department_id);
      this.searchForm.controls["proname"].setValue(this.professor_id);

      this.searchForm.controls["depname"].disable();

      if (this.hod != 1) {
        this.searchForm.controls["proname"].disable();
      }

      // Default chips
      const dept = (this.dept || []).find(x => x.id == this.department_id);
      if (dept) {
        this.chiparray.push("Dept: " + dept.name);
      }

      const professor = (this.professorData || []).find(
        x => x.id == this.professor_id
      );
      if (professor) {
        this.chiparray.push(
          "Proff: " + professor.first_name + " " + professor.last_name
        );
      }

    } else {

      this.department_id = null;
      this.professor_id = null;
      this.searchForm.get('depname')?.setValue(null);
      this.searchForm.get('proffname')?.setValue(null);
      this.searchForm.get('proname')?.setValue(null);
      this.professorData = [];
    }

    this.chiparray.unshift(
      "Session : " + this.forms["session"].value
    );

    this.page = 1;
    this.pageshow = true;

    this.videoList = [];
    this.prolength = 0;

    this.getVideoDetails();
  }


  paginationCount(value) {
    this.page = 1;
    if (value >= 5) {
      this.page_size = value;
    }
    this.getVideoDetails();
  }
}
